/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BookingDetailsMain from './BookingDetailsMain';
import BookingDetailsPrice from './BookingDetailsPrice';
import BookingDetailsFeedback from './BookingDetailsFeedback';
import './bookingDetails.scss';
import {getRelevantJobId} from "../../../../utils";

const propTypes = {
    job: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
    onFeedbackPostSuccess: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

class BookingDetails extends Component {
    render() {
        const {
            job,
            notification,
            table,
            onFeedbackPostSuccess,
            location,
            match,
            history,
        } = this.props;
        const style = {
            minWidth: !this.props.job.booking.client_feedback ? '1000px' : null,
        };
        const relevantJobId = getRelevantJobId(job);

        return (
            <div className="booking-details expanded-content">
                <div className="booking-details__inner" style={style}>
                    <div className="booking-details__main-column">
                        <BookingDetailsMain
                            job={job}
                            relevantJobId={relevantJobId}
                            notification={notification}
                            table={table}
                            location={location}
                            match={match}
                            history={history}
                        />
                    </div>
                    <div className="booking-details__price-column">
                        <BookingDetailsPrice
                            job={job}
                            relevantJobId={relevantJobId}
                            notification={notification}
                            table={table}
                            location={location}
                            match={match}
                            history={history}
                        />
                    </div>
                    <div className="booking-details__feedback-column">
                        {job.booking.can_review ? (
                            <BookingDetailsFeedback
                                job={job}
                                relevantJobId={relevantJobId}
                                notification={notification}
                                onFeedbackPostSuccess={onFeedbackPostSuccess}
                                history={history}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

BookingDetails.propTypes = propTypes;

export default BookingDetails;
